module.exports = "<textarea id=\"{{elementId}}\">\n  {{content}}\n</textarea>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/tinymce/tinymce.component.html
// module id = 481
// module chunks = 0